// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState'
import { reducer as actPostRequestsReducer } from './actPostRequests'
import { reducer as actGetFilterRequestReducer } from './actGetFilterRequest'
import { reducer as actPatchRequestsReducer } from './actPatchRequests'
import { reducer as actVerificationReducer } from './actVerification'
import { reducer as actverifiedQuotesReducer } from './actverifiedQuotes'
import { reducer as actGetAllVAtrributesReducer } from './actGetAllVAtrributes'
import { reducer as actDownloadReportReducer } from './actDownloadReport'
import { reducer as actBusinessUnitReducer } from './actBusinessUnit'
import { reducer as actBranchOfficeReducer } from './actBranchOffice'
import { reducer as actBudgetReducer } from './actBudget'
import { reducer as actDeleteRequestReducer } from './actDeleteRequest'
import { reducer as actGetUserReducer } from './actGetUser'
import { reducer as cleanStateReducer } from './cleanState'
import { reducer as actGetMultimediaReducer } from './actGetMultimedia'
import { reducer as actGetPdfReducer } from './actGetPdf'
import { reducer as requestDialogSteps } from './actRequestDialogSteps'
import { reducer as reportPeritadorReducer } from './reportPeritador'
import { reducer as reducerValidateRequest } from './actValidateRequest'
import { reducer as reducerValidateExistingPatent } from './actValidateExistingPatent'
import { LOGOUT_USER } from '../../common/redux/constants'
import { reducer as actGetCarGaleryReducer } from './actGetCarGalery';
import { reducer as actGetRequestReducer } from './actGetRequest';
import { reducer as getVerificationPdfReducer } from './getVerificationPdf';
import { reducer as cleanRequestModalReducer } from './cleanRequestModal';
import { reducer as actOriginChannelReducer } from './actOriginChannel';
import { reducer as getRequestTabsReducer } from './getTabs';
import { reducer as cleanRequestListReducer } from './cleanRequestList';
import { reducer as updateVerifiedQuotes } from './updateVerifiedQuotes';

const reducers = [
  actPostRequestsReducer,
  actGetFilterRequestReducer,
  actPatchRequestsReducer,
  actVerificationReducer,
  actverifiedQuotesReducer,
  actGetAllVAtrributesReducer,
  actDownloadReportReducer,
  actBusinessUnitReducer,
  actBranchOfficeReducer,
  actBudgetReducer,
  actDeleteRequestReducer,
  actGetUserReducer,
  cleanStateReducer,
  actGetMultimediaReducer,
  actGetPdfReducer,
  requestDialogSteps,
  reportPeritadorReducer,
  actGetCarGaleryReducer,
  reducerValidateRequest,
  reducerValidateExistingPatent,
  actGetRequestReducer,
  getVerificationPdfReducer,
  cleanRequestModalReducer,
  actOriginChannelReducer,
  getRequestTabsReducer,
  cleanRequestListReducer,
  updateVerifiedQuotes,
]

export default function reducer(state = initialState, action) {
  let newState
  switch (action.type) {
    // Handle cross-topic actions here
    case LOGOUT_USER:
      newState = initialState;
      break;
    default:
      newState = state
      break
  }
  return reducers.reduce((s, r) => r(s, action), newState)
}
